import { stringify } from 'query-string';
import React from 'react';

import { useGraphRef } from 'src/app/graph/hooks/useGraphRef';
import {
  TimeRangeInfo,
  TimeRangeProvider,
} from 'src/app/graph/operationsPage/timeRangeProvider/TimeRangeProvider';
import Config from 'src/lib/config';
import {
  FieldInsightsListFilterInput,
  OperationInsightsListFilterInput,
  ServiceErrorStatsFilter,
  ServiceQueryStatsFilter,
  ServiceTracePathErrorsRefsFilter,
  ServiceTraceRefsFilter,
  SubgraphInsightsListFilterInput,
} from 'src/lib/graphqlTypes/types';

import {
  ClientFilterInfo,
  ClientProvider,
} from '../clientProvider/ClientProvider';

export type filterTypes =
  | ServiceErrorStatsFilter
  | ServiceTracePathErrorsRefsFilter
  | ServiceTraceRefsFilter
  | ServiceQueryStatsFilter
  | FieldInsightsListFilterInput
  | OperationInsightsListFilterInput
  | SubgraphInsightsListFilterInput;

export interface FilterProviderRenderProps
  extends TimeRangeInfo,
    ClientFilterInfo {
  graphVariant: string;
  filter: filterTypes;
  navigationalQueryString: string;
}

interface Props {
  children: (
    props: FilterProviderRenderProps,
  ) => React.ReactElement<unknown> | null;
  omitSchemaTag?: boolean;
}

function buildFilter({
  clientFilterInfo,
  graphVariant,
  omitSchemaTag,
}: {
  clientFilterInfo: ClientFilterInfo;
  graphVariant: string;
  omitSchemaTag?: boolean;
}) {
  const filter: FilterProviderRenderProps['filter'] = {};

  if (clientFilterInfo && clientFilterInfo.clientFilter) {
    filter.or = clientFilterInfo.clientFilter;
  }
  if (graphVariant && !omitSchemaTag) {
    filter.in = {
      schemaTag:
        !graphVariant || graphVariant === 'current'
          ? ['', 'current']
          : [graphVariant],
    };
  }
  return filter;
}

export const FilterProvider = ({ children, omitSchemaTag }: Props) => {
  const graphRef = useGraphRef();
  return (
    graphRef && (
      <TimeRangeProvider serviceId={graphRef.graphId}>
        {(timeRangeInfo) => (
          <ClientProvider
            from={timeRangeInfo.timeFrom}
            to={timeRangeInfo.timeTo}
          >
            {(clientInfo) =>
              children({
                graphVariant: graphRef.graphVariant,
                filter: buildFilter({
                  clientFilterInfo: clientInfo,
                  graphVariant: graphRef.graphVariant,
                  omitSchemaTag,
                }),
                navigationalQueryString: stringify({
                  ...timeRangeInfo.queryParams,
                  [Config.queryParameters.SelectedVariant]:
                    graphRef.graphVariant,
                }),
                ...timeRangeInfo,
                ...clientInfo,
              })
            }
          </ClientProvider>
        )}
      </TimeRangeProvider>
    )
  );
};
